/**
 * @author yangxiaochuan
 * 内置字段导入错误
 */
import template from './data-mapping-error.html';
import Component from "../../../../../lib/component";
let css = `
.mapping-con{
height:100%;
}
.mapping-con table{
height: calc(100% - 70px);
overflow-y: scroll;
}
table,tbody,tr{
display: block;
}
tr{
line-height:20px;
}
th,td{
display: inline-table;
}
.th1,.td1{
width:60%;
}
.td1{
text-align: left;
margin-left: 5px;
}
.th2,.td2{
width: 38%;
}
.td2{
position: relative;
}
.mapping-head{
background: #FAFAFA;
font-size: 1rem;
line-height: 35px;
font-weight: bolder;
}
.mapping-row{
border-bottom: 1px solid #E9E9E9;
line-height: 30px;
font-size: 1rem;
}
.td2 select{
width: 110px;
border-radius: 3px;
height: 24px;
margin: auto;
display: block;
}
.btn-group a{
position: absolute;
text-align: center;
width: 90px;
height: 30px;
line-height: 30px;
background-color: #0088ff;
border: none;
border-radius: 4px;
box-shadow: none;
font-weight: 400;
font-style: normal;
font-size: 1rem;
color: #FFFFFF!important;
bottom: 20px;
right: 20px;
text-decoration: none;
}
.btn-group .cancel-mapping{
right: 140px;
}
.data-select{
width: 160px;
border: 1px solid #afafaf;
height: 20px;
border-radius: 3px;
margin: auto;
position: relative;
line-height: 20px;
text-indent: 5px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
.data-select:after{
content: '';
display: block;
position: absolute;
right: 5px;
top: 7px;
border-style: solid;
border-width: 5px;
border-color: #B2B2B2 #fff #fff #fff;
height: 0;
width: 0;
font-size: 0;
}
.data-list{
display: none;
position: absolute;
margin: auto;
width: 160px;
margin-left: 27px;
border: 1px solid #afafaf;
background: #fff;
z-index: 1;
}
.search-content{
height: 30px;
overflow: hidden;
background: #F5F5F5;
}
.data-filter{
width: 125px;
margin: auto;
display: block;
margin-top: 5px;
border-radius: 3px;
border: 1px solid #afafaf;
}
.data-ul{
max-height: 130px;
overflow-y: auto;
overflow-x: hidden;
}
.data-ul li{
padding-left: 5px;
}
.data-ul li:hover{
background: #EBEBE4;
}
\`;


`;

let config = {
    template: template,
    data: {
        css: css.replace(/(\n)/g, ''),
    },
    actions: {
    },
    afterRender: function () {
        this.data.style = $("<style></style>").text(this.data.css).appendTo($("head"));
        // this.el.find('.submit-mapping').on('click',(e)=>{
        //     let arr = [];
        //     let isNull = false;
        //     let err = '';
        //     let rows = this.el.find('.mapping-row');
        //     for(let r of rows){
        //         let selectVal = $(r).find('.data-select').html();
        //         if(!$.trim(selectVal)) {
        //             isNull = true;
        //             err = $(r).find('.td1').html();
        //             break;
        //         }
        //         let obj = {
        //             row: $(r).attr('data-row'),
        //             input: selectVal,
        //             dfield: $(r).attr('data-field'),
        //             table_id: $(r).attr('data-table'),
        //             original:$(r).attr('data-original')
        //         }
        //         arr.push(obj)
        //     }
        //     if(isNull) {
        //         alert(err);
        //     }else {
        //         openDataMappingError.hide()
        //         // PMAPI.sendToIframe( window,{
        //         //     key: this.key,
        //         //     type: PMENUM.close_dialog,
        //         //     data: {
        //         //         type: 'submit-mapping',
        //         //         data: JSON.stringify(arr),
        //         //     }
        //         // } )
        //     }
        // })
        // this.el.find('.cancel-mapping').on('click',(e)=>{
        //     openDataMappingError.hide()
        //     // PMAPI.sendToIframe( window,{
        //     //     key: this.key,
        //     //     type: PMENUM.close_dialog,
        //     //     data: {
        //     //         type: ''
        //     //     }
        //     // } )
        // })
        this.el.find('.data-select').on('click',(e)=>{
            this.el.find('.data-list').hide();
            $(e.target).next().toggle();
        })
        this.el.find('.data-ul').on('click',(e)=>{
            let val = e.target.innerHTML;
            $(e.currentTarget).parent().prev().html(val)
            $(e.currentTarget).parent().hide();
        })
        this.el.find('.data-filter').on('input',(e)=>{
            let val = e.target.value;
            let lis = $(e.target).parent().next().find('li');
            for(let li of lis){
                li.style.display = val == '' || li.innerHTML.indexOf(val)!=-1 ? 'block' : 'none';
            }
        })
        this.el.find('.td1').on('click',(e)=>{
            this.el.find('.data-list').hide();
        })
        let _this=this;
        this.el.find('.mapping-row').each((index,obj)=>{
            if(_this.data.buildin_source[$(obj).data('field')] != undefined){
                for(let item of _this.data.buildin_source[$(obj).data('field')]){
                    $(obj).find('.data-ul').append($(`<li title=${item}>${item}</li>`))
                }
            }
        })
    },
    beforeDestory: function () {

    }
};
let dataMappingError=Component.extend(config);
//export default dataMappingError;
let openDataMappingError = {
    el: null,
    show: function (config = {}) {
        this.el = $("<div class='dataMapping-dialog'>").appendTo(document.body);
        let DataMappingError = new dataMappingError(config);
        DataMappingError.render(this.el);
        this.el.erdsDialog({
            width: 580,
            height: 360,
            title: '错误处理',
            modal: true,
            // maxable: true,
            // defaultMax: false,
            close: function () {
                $(this).erdsDialog('destroy');
                DataMappingError._destroy();
            }
        })
    },
    hide:function () {
        this.el.erdsDialog('close');
    }
}

export {openDataMappingError}


// WEBPACK FOOTER //
// app/components/dataGrid/data-table-toolbar/data-table-import/data-mapping-error/data-mapping-error.js